import axios from "axios";

export const getAdTypes = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/reports/getAdTypes/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const getGeneralReport = (
  careersClientId,
  startDate,
  endDate,
  industryType,
  familyType,
  categoryType,
  optIn,
  aggregate
) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/reports/" +
        encodeURIComponent(careersClientId) +
        "/" +
        encodeURIComponent(startDate) +
        "/" +
        encodeURIComponent(endDate) +
        "/" +
        encodeURIComponent(optIn) +
        "/" +
        encodeURIComponent(aggregate),
      {
        params: {
          ...(industryType !== null ? { industryType: industryType } : {}),
          ...(familyType !== null ? { familyType: familyType } : {}),
          ...(categoryType !== null ? { categoryType: categoryType } : {}),
        },
      }
    )
    .then((res) => res.data);
};

export const getTypeReport = (
  careersClientId,
  startDate,
  endDate,
  adType,
  optIn
) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/reports/getReport/" +
        encodeURIComponent(careersClientId) +
        "/" +
        encodeURIComponent(startDate) +
        "/" +
        encodeURIComponent(endDate) +
        "/" +
        encodeURIComponent(adType) +
        "/" +
        encodeURIComponent(optIn)
    )
    .then((res) => res.data);
};

export const getUserList = (careersClientId, users) => {
  var data = JSON.stringify(users);
  var config = {
    method: "post",
    url:
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
      "/api/reports/getUserList/" +
      encodeURIComponent(careersClientId),
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  axios(config)
    .then(function (res) {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export_data.csv");
      document.body.appendChild(link);
      link.click();
      return true;
    })
    .catch(function (error) {
      console.log(error);
      return false;
    });
};
